import { selectDefaultAccount } from '../state/userSlice';
import { useSelector } from 'react-redux';

const useDefaultAccount = () => useSelector(selectDefaultAccount);

export default useDefaultAccount;
